// extracted by mini-css-extract-plugin
export var row = "_uq-0";